const ENV_USERS = process.env.REACT_APP_LOGIN_USERS;

// Check if ENV_USERS exists and is not empty
export const USERS = ENV_USERS
  ? ENV_USERS.split(',').map(pair => {
      const [username, password] = pair.split(':');
      return { username, password };
    })
  : [];